import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {useNavigate} from "react-router-dom";
import {Menu, useTheme} from "@mui/material";
import {getAuth, signOut} from "firebase/auth";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import {useContext} from "react";
import {AppContext} from "../services/AppContext";

const drawerWidth = 240;
const navItems = [
  {name: 'Services', route: 'https://www.anothermarslife.com/services'},
  {name: 'Subscribe', route: 'subscribe'},
  {name: 'Book Now', route: 'book'}];

function CustomMenuAppBar() {
  const navigate = useNavigate()
  const {state: {masterReset}, dispatch} = useContext(AppContext)
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const theme = useTheme()
  const auth = getAuth()


  // THIS IS FOR MOBILE
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{textAlign: 'center'}}>
      <Typography 
        variant="h5" 
        sx={{
          my: 2,
          fontWeight: 700,
          background: 'linear-gradient(135deg, #6366f1 0%, #8b8cf8 100%)',
          backgroundClip: 'text',
          textFillColor: 'transparent',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          cursor: 'pointer'
        }} 
        onClick={() => navigate('/dashboard')}
      >
        Tomira Storage
      </Typography>
      <Divider/>
    </Box>
  );

  // const container = window !== undefined ? () => window().document.body : undefined;

  function navigateMenu(e) {
    const route = e.currentTarget.getAttribute('route')
    if (route.includes('www')) {
      window.location.href = route;
    } else {
      dispatch({masterReset: masterReset + 1})
      navigate('/' + route, {replace: true})
    }
  }

  function signOutLocal() {
    signOut(auth).then(() => {
      console.log('logging out')
      // Clear the current user from context
      dispatch({ currentUser: null })
      navigate('/login')
    }).catch((error) => {
      console.log(error)
    });
  }

  return (
    <Box sx={{display: 'flex'}}>
      <AppBar component="nav" elevation={0} sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(229, 231, 235, 0.8)'
      }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{mr: 2, display: {sm: 'none'}}}
          >
            <MenuIcon/>
          </IconButton>
          <Typography
            variant="h5"
            component="div"
            sx={{
              flexGrow: 1, 
              display: {xs: 'none', sm: 'block'},
              fontWeight: 700,
              background: 'linear-gradient(135deg, #6366f1 0%, #8b8cf8 100%)',
              backgroundClip: 'text',
              textFillColor: 'transparent',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              cursor: 'pointer'
            }}
            onClick={() => navigate('/dashboard')}
          >
            Tomira Storage
          </Typography>
          <Box sx={{display: {xs: 'none', sm: 'block'}}}>
            {auth.currentUser &&
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar alt={auth.currentUser.displayName} src={auth.currentUser.photoURL}/>
            </IconButton>
            }

            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {/*<MenuItem onClick={() => {*/}
              {/*  navigate('/profile');*/}
              {/*  handleClose()*/}
              {/*}}>My account</MenuItem>*/}
              <MenuItem onClick={() => {
                signOutLocal()
              }}>Log Out</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          // container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: {xs: 'block', sm: 'none'},
            '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

CustomMenuAppBar.propTypes =
  {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
  }
;

export default CustomMenuAppBar;
